module.exports = __webpack_public_path__ + "logo-MOP.png?e269f1a278f65a67c3007356eb0f62f7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/clients/logo-MOP.png
// module id = 78
// module chunks = 0